import { Component, Input, signal, Signal } from '@angular/core';
import { actionInput, buttonConfig, dropdownConfig } from '@core/types/types';
import { TranslateModule } from '@ngx-translate/core';
import { CustomButtonComponent } from '@shared/components';
import { CustomDropdownComponent } from '@shared/components/selectbox';
import { getThemeVariables } from 'src/app/theme/theme-variables';

@Component({
  imports: [TranslateModule, CustomDropdownComponent, CustomButtonComponent],
  standalone: true,
  selector: 'group-buttons-component',
  templateUrl: './group-buttons.component.html',
})
export class CustomGroupButtonsComponent {
  @Input({ required: true }) config!: buttonConfig[];
  @Input({ required: true }) data!: any;

  protected dropdownConfig = signal<any>({
    type: 'dropdown',
    dropdownContainer: 'body',
    actions: [],
  });

  protected dropdownModeActive: boolean = false;

  ngOnInit() {
    this.dropdownModeActive =
      window.innerWidth < getThemeVariables().breakpoints.lg;

    this.config.forEach((btn) => {
      if (btn.type == 'action') {
        const action = {
          name: btn.label.key,
          label: btn.label.key,
          icon: btn.icon,
          action: () => btn.action(this.data),
        } as actionInput;

        this.dropdownConfig.update((config) => {
          config.actions.push(action);
          return config;
        });
      }
    });
  }
}
